import '../styles/main.sass';
import '../resources/images/map.jpg';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.fullscreen';
import 'leaflet-control-custom';

import 'web-animations-js';
import eases from './web-animation-eases.js';

import 'whatwg-fetch'

function importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
        images[item.replace('./', '')] = r(item);
    });
    return images;
}

const balloons = importAll(require.context('../resources/images/balloons', false, /\.(svg)$/));
// const controls = importAll(require.context('../resources/images/controls', false, /\.(svg)$/));
const modals = importAll(require.context('../resources/images/modals', false, /\.(jpg|svg)$/));

function map(value, start1, stop1, start2, stop2) {
    return start2 + (stop2 - start2) * ((value - start1) / (stop1 - start1));
}

class Main {

    constructor() {
        fetch('assets/index/js/coordinate.json', {
            credentials: 'same-origin'
        }).then((response) => {
            return response.json()
        }).then((json) => {
            this.coordinates = json;
            this.init();
        });
    }

    init() {
        this.balloonImages = {};

        // Preload balloon images
        this.coordinates.markers.forEach(c => {
            const image = new Image();
            image.src = balloons[`balloon-${c.name}.svg`];
            this.balloonImages[c.name] = image;
        });
        this.initMap();
    }

    initMap() {
        const minZoomLv = -1.85;
        const maxZoomLv = -0.8;

        this.map = L.map('mv-map', {
            crs: L.CRS.Simple,
            minZoom: minZoomLv,
            maxZoom: maxZoomLv,
            maxBoundsViscosity: 1.0,
            attributionControl: false,
            zoomSnap: 0,
            zoomDelta: 0.25,
            // fadeAnimation: false,
            // fullscreenControl: true,
        });

        const yx = L.latLng;

        const xy = (x, y) => {
            if (L.Util.isArray(x)) {
                return yx(x[1], x[0]);
            }
            return yx(y, x);
        };

        const bounds = [xy(0, 0), xy(8695, 4175)];
        const image = L.imageOverlay('assets/index/img/map.jpg', bounds).addTo(this.map);

        this.map.setView(xy(4347.5, 2087.5), minZoomLv);
        this.markers = new L.FeatureGroup();
        this.secrets = new L.FeatureGroup();

        this.populate();
        this.map.addLayer(this.markers);
        this.map.addLayer(this.secrets);

        this.map.setMaxBounds(bounds);
        this.map.fitBounds(bounds);

        // Create a fullscreen button and add it to the map
        const container = document.getElementById('mv-map-container');
        L.control.fullscreen({
            position: 'bottomright',
            title: '全画面モード',
            titleCancel: '全画面モードをやめる',
            fullscreenElement: container
        }).addTo(this.map);

        if (this.isSp()) {
            const fullscreenEl = document.getElementsByClassName('leaflet-control-zoom-fullscreen')[0];
            fullscreenEl.style.display = 'none';
        }

        const panToLeftBtn = L.control.custom({
            position: 'topleft',
            content: '<button type="button" class="btn btn-default pan-to-left"></button>',
            classes: 'btn-group-vertical btn-group-sm',
            style: {
                margin: '10px',
                padding: '0px 0 0 0',
                cursor: 'pointer'
            },
            events: {
                click: () => {
                    const center = this.map.getCenter();
                    this.map.panTo(new L.LatLng(center.lat, center.lng - 200));
                },
            },
        }).addTo(this.map);

        const panToRightBtn = L.control.custom({
            position: 'topright',
            content: '<button type="button" class="btn btn-default pan-to-right"></button>',
            classes: 'btn-group-vertical btn-group-sm',
            style: {
                margin: '10px',
                padding: '0px 0 0 0',
                cursor: 'pointer',
            },
            events: {
                click: () => {
                    const center = this.map.getCenter();
                    this.map.panTo(new L.LatLng(center.lat, center.lng + 200));
                },
            },
        }).addTo(this.map);

        // Events are fired when entering or exiting fullscreen.
        this.map.on('enterFullscreen', () => {
            document.getElementById('mv-map').classList.add('fullscreen');
            document.getElementById('mv-attention-image-pc').style.display = 'none';
            document.getElementById('mv-attention-image-sp').style.display = 'none';
        });

        this.map.on('exitFullscreen', () => {
            document.getElementById('mv-map').classList.remove('fullscreen');
            document.getElementById('mv-attention-image-pc').style.display = 'block';
            document.getElementById('mv-attention-image-sp').style.display = 'block';
        });

        this.prevZoomLv = minZoomLv;
        this.map.on('zoomend', () => {
            const zoomLv = this.map.getZoom();
            const scale = map(zoomLv, minZoomLv, maxZoomLv, 1, 2);

            const markerEls = document.getElementsByClassName('mv-marker');
            [].forEach.call(markerEls, markerEl => {
                markerEl.style.transform = `${markerEl.style.transform} scale(${scale})`;
            });

            if (this.isOpened) {
                this.markers.eachLayer(marker => {
                    const name = marker.coordinate.name;
                    const balloonEl = document.getElementById(`balloon-${name}`);
                    if (!balloonEl) return;
                    balloonEl.style.transform = `scale(${scale})`;
                });
            }
        });

        // Animate popup
        this.map.on('popupopen', e => {
            const marker = e.popup._source;
            const name = marker.coordinate.name;
            const balloonEl = document.getElementById(`balloon-${name}`);
            const currZoomLv = this.map.getZoom();
            const scale = map(currZoomLv, minZoomLv, maxZoomLv, 1, 2);
            balloonEl.onload = () => {
                // const balloonElAnim = balloonEl.animate(eases.elasticOut({ keyframes: 100 })(x => ({
                //     transform: `scale(${map(x, 0, 1, 0, scale)})`
                // })), {
                //     duration: 300
                // });

                const balloonElAnim = balloonEl.animate(eases.elasticOut({ keyframes: 100 })(x => ({
                    transform: `scale(${map(x, 0, 1, 0, scale)})`
                })), {
                    duration: 300
                });
                balloonElAnim.onfinish = () => {
                    balloonEl.style.transform = `scale(${scale})`;
                };
            };
        });

        const zoomIn = document.getElementsByClassName('leaflet-control-zoom-in')[0];
        const zoomOut = document.getElementsByClassName('leaflet-control-zoom-out')[0];
        zoomIn.title = '拡大する';
        zoomOut.title = '縮小する';

        // L.control.coordinates({
        //     position: 'bottomleft'
        // }).addTo(this.map);

        const openPopupBtn = document.getElementById('mv-open-all-popup');
        openPopupBtn.addEventListener('click', e => {
            if (this.isOpened) {
                openPopupBtn.textContent = '答えを見る';
                this.isOpened = false;

                this.markers.eachLayer(marker => {
                    marker.closePopup();
                });

                const noticeImage = document.getElementById('mv-notice-image');
                const noticeImageAnim = noticeImage.animate([{ opacity: 1 }, { opacity: 0 }], 150);
                noticeImageAnim.onfinish = () => {
                    noticeImage.style.display = 'none';
                    noticeImage.style.opacity = 0;
                };
            } else {
                this.isOpened = true;
                openPopupBtn.textContent = '答えを隠す';

                this.markers.eachLayer(marker => {
                    marker.openPopup();
                    const name = marker.coordinate.name;
                    const balloonEl = document.getElementById(`balloon-${name}`);
                    const callback = () => {
                        this.openModal(marker.coordinate);
                    };
                    balloonEl.removeEventListener('click', callback);
                    balloonEl.addEventListener('click', callback);
                });

                const noticeImage = document.getElementById('mv-notice-image');
                noticeImage.style.display = 'block';
                noticeImage.style.opacity = 1;
                noticeImage.style.transform = 'scale(0)';
                const noticeImageAnim = noticeImage.animate(eases.elasticOut({keyframes: 100})(x => ({
                    transform: `scale(${x})`,
                })), {
                    duration: 450,
                    delay: 1000,
                });
                noticeImageAnim.onfinish = () => {
                    noticeImage.style.transform = 'scale(1)';
                };
            }
        });

        // document.getElementById('mv-close-all-popup').addEventListener('click', () => {
        //     this.markers.eachLayer(marker => {
        //         marker.closePopup();
        //     });
        // });

        document.getElementById('mv-modal-close').addEventListener('click', () => {
            this.closeModal();
        });

        document.getElementById('mv-attention-image-pc').animate([
            { transform: 'translateY(0px)' },
            { transform: 'translateY(-6px)' },
            { transform: 'translateY(0px)' }
        ], {
            duration: 1000,
            delay: 0,
            iterations: Infinity,
            easing: 'ease-in-out'
        });

        document.getElementById('mv-attention-image-sp').animate([
            { transform: 'translateY(0px)' },
            { transform: 'translateY(-6px)' },
            { transform: 'translateY(0px)' }
        ], {
            duration: 1000,
            delay: 0,
            iterations: Infinity,
            easing: 'ease-in-out'
        });

        document.getElementById('mv-modal-link').addEventListener('click', () => {
            const modalDetailContainer = document.getElementById('mv-modal-detail-container');

            modalDetailContainer.style.display = 'block';
            modalDetailContainer.animate([{ opacity: 0 }, { opacity: 0.3 }], 150);

            if (!this.selectedCoordinate) return;

            this.insertHtmlToModalDetail(this.selectedCoordinate['modal-link']);

            const modalDetail = $('#mv-modal-detail');
            modalDetail.removeClass();
            modalDetail.addClass('mv-modal-detail');
            const categoryName = this.selectedCoordinate['name'];
            if (categoryName.startsWith('architecture')) {
                modalDetail.addClass('architecture-wrap');
            }
            else if (categoryName.startsWith('civil')) {
                modalDetail.addClass('civil-wrap');
            }
            else if (categoryName.startsWith('energy')) {
                modalDetail.addClass('energy-wrap');
            }
            else if (categoryName.startsWith('lab')) {
                modalDetail.addClass('lab-wrap');
            }
            else if (categoryName.startsWith('mokkou')) {
                modalDetail.addClass('mokkou-wrap');
            }
            else if (categoryName.startsWith('future')) {
                modalDetail.addClass('future-wrap');
            }
        });
    }

    getRandomLatLng(map) {
        let bounds = map.getBounds(),
            southWest = bounds.getSouthWest(),
            northEast = bounds.getNorthEast(),
            lngSpan = northEast.lng - southWest.lng,
            latSpan = northEast.lat - southWest.lat;

        return new L.LatLng(
            southWest.lat + latSpan * Math.random(),
            southWest.lng + lngSpan * Math.random());
    }

    populate() {
        this.markers.clearLayers();
        for (let i = 0; i < 16; i++) {
            const coordinate = this.coordinates.markers[i];
            let markerIcon = L.divIcon({
                iconSize: L.point(64, 64),
                popupAnchor: L.point(0, 0),
                className: `mv-marker mv-marker-${coordinate.name}`,
            });
            // let latLng = this.getRandomLatLng(this.map);
            let latLng = new L.LatLng(coordinate.y, coordinate.x);
            let marker = L.marker(latLng, {
                icon: markerIcon
            });
            // marker.bindPopup(coordinate['modal-text']);
            marker.bindPopup(`<img src="${this.balloonImages[coordinate.name].src}" class="mv-balloon-popup mv-balloon-popup-${coordinate.name}" id="balloon-${coordinate.name}">`, {
                autoClose: false,
                closeOnClick: false,
            });
            marker.coordinate = coordinate;

            marker.on('mouseover', e => {
            });
            marker.on('mouseout', e => {
            });
            marker.off('click', this.openPopup);
            marker.on('click', () => {
                this.openModal(coordinate);
            });

            this.markers.addLayer(marker);
        }

        this.secrets.clearLayers();
        for (let i = 0; i < 9; i++) {
            const coordinate = this.coordinates.secrets[i];
            let markerIcon = L.divIcon({
                iconSize: L.point(64, 64),
                popupAnchor: L.point(0, 0),
                className: `mv-marker mv-secret-${i}`,
            });
            // let latLng = this.getRandomLatLng(this.map);
            let latLng = new L.LatLng(coordinate.y, coordinate.x);
            let marker = L.marker(latLng, {
                icon: markerIcon
            });
            marker.coordinate = coordinate;

            marker.off('click', this.openPopup);
            marker.on('click', e => {
                window.open(coordinate.link);
            });

            this.secrets.addLayer(marker);
        }
        return false;
    }

    openModal(coordinate) {
        const modalHead = document.getElementById('mv-modal-head');
        const modalText = document.getElementById('mv-modal-text');
        const modalImage = document.getElementById('mv-modal-image');
        const modalLink = document.getElementById('mv-modal-link');

        this.selectedCoordinate = coordinate;

        modalHead.src = `assets/index/img/head-${coordinate.name}.svg`;
        modalText.innerText = coordinate['modal-text'];
        modalImage.src = `assets/index/img/mv-modal-${coordinate.name}.jpg`;
        modalLink.href = coordinate['modal-link'];

        const modal = document.getElementById('mv-modal');
        const modalOverlay = document.getElementById('mv-modal-overlay');

        modal.style.display = 'flex';
        modal.animate([{ opacity: 0 }, { opacity: 1 }], 150);

        modalOverlay.style.display = 'block';
        modalOverlay.animate([{ opacity: 0 }, { opacity: 0.3 }], 150);
    }

    closeModal() {
        const modal = document.getElementById('mv-modal');
        const modalOverlay = document.getElementById('mv-modal-overlay');

        // modal.style.display = 'none';
        // modalOverlay.style.display = 'none';

        const modalAnim = modal.animate([{ opacity: 1 }, { opacity: 0 }], 150);
        const modalOverlayAnim = modalOverlay.animate([{ opacity: 0.3 }, { opacity: 0 }], 150);

        modalAnim.onfinish = () => { modal.style.display = 'none'; };
        modalOverlayAnim.onfinish = () => { modalOverlay.style.display = 'none'; };
    }

    isSp() {
        return window.navigator.userAgent.match(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i) !== null;
    }

    insertHtmlToModalDetail(url) {
        $.ajax(url, {
            timeout : 1000,
            datatype: 'html'
        }).then((data) => {
            const html = $($.parseHTML(data));
            const modalDetailContainer = $('#mv-modal-detail-container');
            const modalDetail = $('#mv-modal-detail');
            modalDetail.empty().append(html.find('#container')[0]);
            modalDetailContainer.height($(document).height());

            const modalDetailClose = document.getElementById('mv-modal-detail-close');
            modalDetailClose.addEventListener('click', e => {
                const modalDetailContainer = document.getElementById('mv-modal-detail-container');

                const modalDetailContainerAnim = modalDetailContainer.animate([{ opacity: 1 }, { opacity: 0 }], 150);
                modalDetailContainerAnim.onfinish = () => { modalDetailContainer.style.display = 'none'; };

                this.closeModal();
            });

            const modalDetailCloseBottom = document.getElementById('mv-modal-detail-close-bottom');
            modalDetailCloseBottom.addEventListener('click', e => {
                const modalDetailContainer = document.getElementById('mv-modal-detail-container');

                const modalDetailContainerAnim = modalDetailContainer.animate([{ opacity: 1 }, { opacity: 0 }], 150);
                modalDetailContainerAnim.onfinish = () => { modalDetailContainer.style.display = 'none'; };

                this.closeModal();
            });
        }, (xhr, status) => {
        });
    }

}

module.exports = new Main();



// WEBPACK FOOTER //
// ./scripts/main.js